/** Currency metadata recognized in stored and provider data. */
export const CURRENCIES = [
  { code: "BRL", name: "Brazilian Real", symbol: "R$" },
  { code: "USD", name: "US Dollar", symbol: "$" },
  { code: "EUR", name: "Euro", symbol: "\u20ac" },
] as const;

export type CurrencyCode = (typeof CURRENCIES)[number]["code"];

export const USER_SELECTABLE_CURRENCY_CODES = ["BRL"] as const satisfies readonly CurrencyCode[];

const USER_SELECTABLE_CURRENCY_CODE_SET = new Set<CurrencyCode>(USER_SELECTABLE_CURRENCY_CODES);

export const USER_SELECTABLE_CURRENCIES = CURRENCIES.filter((currency) =>
  USER_SELECTABLE_CURRENCY_CODE_SET.has(currency.code),
);
